/*-- import aliases -----------
'!/...' -> project root
'~/...' -> js folder root
-----------------------------*/
import { setup } from '~/core';
setup();

import '~/global/_body';
import '~/global/_header';
import '~/global/_footer';
import '~/global/_siteModals';

import '~/components/_accordion';
import '~/components/_profile';
import '~/components/_forms';
import '~/components/_card';
import '~/components/_secondaryNav';
import '~/components/_tabs';
import '~/components/_tableDetail';
import '~/components/_videoLazy';
import '~/components/_videoModal';
